{
  "in_progress": "En cours",
  "waiting_payment": "En attente de payment",
  "finished": "Terminé",
  "pending": "En attente",
  "all": "Tous",
  "newest_first": "Plus recent",
  "oldest_first": "Plus acien"
}
